import type { CvContent } from './types'

export const nl: CvContent = {
  tagline: 'Performer · Danser · Zangeres · Dansdocent',
  intro:
    'Student BA Dans / BA Docent dans aan Lucia Marthas Institute for Performing Arts. Podiumervaring in o.a. de Ziggo Dome, Ahoy en AFAS Live, en dance captain bij de jaarlijkse eindpresentatie van LMIPA.',
  about:
    'Ik ben een enthousiaste en flexibele performer met een groot verantwoordelijkheidsgevoel. Als echte doorzetter ben ik betrouwbaar en altijd punctueel. Ik werk georganiseerd, houd mijn taken goed op orde en ben een teamspeler die snel schakelt wanneer dat nodig is. Naast mijn werk op het podium geef ik ook met veel plezier les, waarbij ik mijn passie voor musical en podiumkunsten graag overdraag op anderen. Met mijn positieve energie en toewijding draag ik bij aan een soepele en succesvolle productie.',
  features: [
    { label: 'Haarkleur', value: 'Blond' },
    { label: 'Ogen', value: 'Blauw' },
    { label: 'Lengte', value: '1.70 m' },
    { label: 'Geboortedatum', value: '27/03/2005' },
  ],
  skills: [
    {
      heading: 'Zang',
      lines: ['Stemsoort: Sopraan', 'Vocal range: E3 tot C6', 'Training in:'],
      items: ['Jazz', 'Musical', 'Pop', 'Klassiek', 'Ensemble en meerstemmigheid'],
    },
    {
      heading: 'Dans',
      lines: ['Training in:'],
      items: [
        'Ballet',
        'Jazz',
        'Horton',
        'Modern',
        'Verschillende Latin stijlen en lift werk',
        'Musical theater',
        'Commercial',
        'Tap',
      ],
    },
    {
      heading: 'Acteren',
      lines: [],
      items: [
        'Improvisatie',
        'Groep scenes',
        'Monologen',
        'Duologen',
        'Theater en camera acteren',
      ],
    },
  ],
  experience: [
    {
      title: 'Jaarlijkse eindpresentatie LMIPA',
      period: '2014 jul – heden',
      description:
        'Tijdens de jaarlijkse eindpresentatie ben ik als dance captain verantwoordelijk geweest voor verschillende stukken. Daarnaast heb ik choreografieën gemaakt voor de jongere afdelingen, waarbij ik mijn creativiteit en ervaring als dansdocent heb ingezet.',
    },
    { title: 'Christmas Show, Ziggo Dome', period: 'Dec 2016' },
    { title: 'Kinderen voor Kinderen 40 jaar, Ahoy', period: '2018' },
    { title: 'Lang Leve de Muziek Show AVROTROS', period: '2018 – 2019' },
    { title: 'Katja en Babbette Discobal AFAS Live', period: 'Nov 2025' },
    {
      title: 'Workshops',
      period: '2023 – heden',
      bullets: [
        'Workshops/lessen van Malou Linders, Denden Karadeniz, Sergio Reis, Jordy Sparidaens, Anneke Ghysens en Laurent Flamment',
        'Workshops/lessen van Caroline Dijkhuizen, Andy Señor JR, Mary-Ann Lamb, Valerie Pettifort en Michiel Varga',
      ],
    },
    {
      title: 'Docent dans Lucia Marthas Institute for Performing Arts',
      period: '2023 sept – heden',
    },
  ],
  education: [
    {
      period: '2023',
      school: 'Gerrit van der Veen College',
      detail: 'VWO / DAMU klas LMIPA',
    },
    {
      period: 'Sept 2023 – juli 2027',
      school: 'Lucia Marthas Institute for Performing Arts',
      detail: 'BA Dans / BA Docent dans',
    },
  ],
}
